import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // stateBaseURL: 'http://www.china-crown.com/en/index.php/api/v1/',
    stateBaseURL: 'https://www.hs-decorations.com/index.php/api/v1/',
    // stateimgBaseURL: 'http://www.china-crown.com/en/',
    stateimgBaseURL: 'https://www.hs-decorations.com/',
    statePerInfor: '',
    stateToken: '',
    stateTableHeader: {
      'background': '#e6eae9',
      'color': '#333333'
    },
    stateNews_getNewsType: '',
    stateIndex_link: '',
    stateUpload: 'basis/uploadImage',
    stateProdClass: '',//产品分类
  },
  mutations: {
    mutationsPerInfor(state, newstatePerInfor) {
      state.statePerInfor = newstatePerInfor
    },
    mutationsNews_getNewsType(state, newstateNews_getNewsType) {
      state.stateNews_getNewsType = newstateNews_getNewsType
    },
    mutationsIndex_link(state, newstateIndex_link) {
      state.stateIndex_link = newstateIndex_link
    },
    mutationsProdClass(state, newstateProdClass) {
      state.stateProdClass = newstateProdClass
    },
  },
  actions: {},
  modules: {}
})
